import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHost } from "./utils";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

export const getHolidaycheckOverall = createAsyncThunk("cache/holidaycheckoverall", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/holidaycheck/hotel/0/" + encodeURIComponent(payload.HotelGiataID));

    return Array.isArray(response.data.items) && response.data.items.length > 0 ? response.data.items[0] : {};
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getGiataGallery = createAsyncThunk("cache/giatagallery", async (payload, thunkAPI) => {
  //console.log("+++++++++++", payload);
  try {
    const vcParam = Array.isArray(payload.giataoperators) && payload.giataoperators.length > 0 ? `?vc=${payload.giataoperators.join(",")}` : "";
    const response = await axios.get(getHost() + "/giatagallerysmall/" + encodeURIComponent(payload.HotelGiataID) + vcParam);

    let catidx = -1;
    let piccnt = 0;

    if (Array.isArray(response?.data?.result?.data) && response?.data?.result?.data.length > 0) {
      for (let i = 0; i < response.data.result.data.length; i++) {
        if (Array.isArray(response.data.result.data[i].Bildfile)) {
          if (response.data.result.data[i].Bildfile.length > piccnt) {
            piccnt = response.data.result.data[i].Bildfile.length;
            catidx = i;
          }
        }
      }
    }

    let picts = [];

    if (catidx > -1) {
      picts = response.data.result.data[catidx].Bildfile.map((e) => e["_"]);
    }
    return picts;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

const initialState = {
  agencyPictures: {},
  giataSmallGalleries: {},
  holidaycheckOverall: {},
  // Liefert die HolidayCheck-Quelle ueberhaupt? null = noch keine Antwort gesehen.
  // Der Unterschied, auf den es ankommt: ein HTTP-Fehler heisst "Quelle tot"
  // (aktuell 500, weil holidaycheck.de per Akamai sperrt), eine leere Antwort
  // heisst nur "dieses Hotel ist unbewertet". Ohne die Trennung sah ein
  // Totalausfall aus wie "kein Hotel erfuellt das Kriterium" — der Filter warf
  // dann jedes Hotel raus und die Trefferliste war leer.
  holidaycheckAvailable: null,
};

const cacheSlice = createSlice({
  name: "cache",
  initialState,
  reducers: {
    setAgencyPictures: (state, action) => {
      state.agencyPictures[action.payload.HotelGiataID] = action.payload.pictures;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGiataGallery.fulfilled, (state, { payload, meta }) => {
      state.giataSmallGalleries[meta.arg.HotelGiataID] = payload;
    });
    builder.addCase(getHolidaycheckOverall.fulfilled, (state, { payload, meta }) => {
      state.holidaycheckOverall[meta.arg.HotelGiataID] = payload;
      // Antwort da = Quelle lebt, auch wenn dieses Hotel keine Bewertung hat.
      state.holidaycheckAvailable = true;
    });
    builder.addCase(getHolidaycheckOverall.rejected, (state) => {
      state.holidaycheckAvailable = false;
    });
  },
});

export const { setAgencyPictures } = cacheSlice.actions;
export default cacheSlice.reducer;
